// @ts-nocheck
/* eslint-disable */

import * as React from 'react';

export const shuffle = (array: Array<any>) => {
  let currentIndex = array.length;
  let randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    // eslint-disable-next-line no-plusplus
    currentIndex--;

    // And swap it with the current element.
    // eslint-disable-next-line no-param-reassign
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const animation = (
  initialArray,
  maxItemQuantity = 12,
  onClickButton,
  numberOfRows,
  title,
) => {
  const array = shuffle([...initialArray]);
  const bodyWidth = document.body.clientWidth;
  const maxQuantityOfItems = maxItemQuantity;

  const floatingArea = document.getElementById('floating-area');
  const floatingSection = document.createElement('article');
  floatingArea.appendChild(floatingSection);

  for (let i = 0; i < numberOfRows; i++) {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.setAttribute('row', i.toString());
    floatingSection.appendChild(wrapperDiv);
  }

  let count = maxQuantityOfItems + 1;
  let elementIndex = maxQuantityOfItems;

  // Function to place the div randomly out of the right edge of the viewport
  function placeRandomlyRightEdge(element) {
    if (count <= array.length - 1) {
      elementIndex = count;
    } else {
      elementIndex = count % array.length;
    }
    count++;

    // Getting minimal left position for the repositioned element, based on siblings
    const minLeftPosition = getMinLeftPosition(element);

    element.classList.remove('animated');
    // Position each div randomly initially
    // eslint-disable-next-line no-param-reassign
    element.style.left = `${
      minLeftPosition < bodyWidth
        ? bodyWidth
        : minLeftPosition +
          element.getBoundingClientRect().width +
          randomIntFromInterval(150, 300)
    }px`;
    // eslint-disable-next-line no-param-reassign
    element.style.top = `0px`;
    element.innerText = array[elementIndex][title];
  }

  // Floating animation function for a single div
  function floatAnimation(element) {
    const step = parseInt(element.parentElement.getAttribute('row')) * 2 || 2; // Change this value to control the animation speed
    const leftPos = parseFloat(element.style.left);
    const widthPos = element.getBoundingClientRect().width * -1;

    if (
      window.innerWidth / 2 - leftPos < 10 &&
      window.innerWidth / 2 - leftPos > 0
    ) {
      // eslint-disable-next-line no-param-reassign
      element.classList.add('animated');
    }

    if (leftPos > widthPos) {
      // Check if the div is not yet hidden
      // eslint-disable-next-line no-param-reassign
      element.style.left = `${leftPos - step}px`;

      requestAnimationFrame(() => floatAnimation(element));
    } else {
      requestAnimationFrame(() => floatAnimation(element)); // Continue animation after resetting
      placeRandomlyRightEdge(element); // Place the div randomly on the right edge
    }
  }

  // Create and animate 10 divs initially
  // eslint-disable-next-line no-plusplus
  let wrapperCount = 0;
  for (let i = 0; i < maxQuantityOfItems; i++) {
    const div = document.createElement('div');

    div.className = 'floating-button';

    // redirect to a page on button click
    div.addEventListener('click', () => onClickButton(array[i]));
    if (wrapperCount >= numberOfRows) {
      wrapperCount = 0;
    }

    const randomWrapper = floatingSection.childNodes[wrapperCount];

    let left = randomWrapper.childNodes[0];

    if (randomWrapper.childNodes.length === 0) {
      left = randomIntFromInterval(50, 300);
    } else if (randomWrapper.childNodes.length === 1) {
      left = randomIntFromInterval(1000, 1500);
    } else {
      left = randomIntFromInterval(bodyWidth, 1.5 * bodyWidth);
    }

    div.style.left = `${left}px`;
    div.style.top = `0px`;
    div.innerText = array[i][title];

    randomWrapper.appendChild(div);
    // Start the floating animation for each div
    floatAnimation(div);

    wrapperCount++;
  }
};

const randomIntFromInterval = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);

const getMinLeftPosition = (element) => {
  let maxChildLeftPosition = 0;

  Array.from(element.parentElement.childNodes).forEach((el) => {
    if (el !== element) {
      const { width, left } = el.getBoundingClientRect();
      maxChildLeftPosition =
        width + left > maxChildLeftPosition
          ? width + left
          : maxChildLeftPosition;
    }
  });

  return maxChildLeftPosition;
};
